import "./bootstrap";
import "../css/app.css";

// SFC şablonları Vite ile önceden derlenir; tarayıcıya şablon derleyicisi taşımayız.
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/vue3";
import { resolvePageComponent } from "laravel-vite-plugin/inertia-helpers";
import { ZiggyVue } from "../../vendor/tightenco/ziggy/dist/index.esm";

const appName = window.document.getElementsByTagName("title")[0]?.innerText || "Laravel";

import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
    apiKey: "b9a30b5e49f7a62c7ed3880fd63f27a9",
    plugins: [new BugsnagPluginVue()],
    onError: (event) => {
        const errorMessage = event?.errors?.[0]?.errorMessage || "";
        if (errorMessage.includes("ResizeObserver loop completed with undelivered notifications") || errorMessage.includes("ResizeObserver loop limit exceeded") || errorMessage.includes("window.webkit.messageHandlers")) {
            return false;
        }

        if (errorMessage === "Network Error" || errorMessage === "Request aborted" || errorMessage.includes("Request aborted")) {
            const breadcrumbs = event.breadcrumbs || [];
            const hasInertiaNavigation = breadcrumbs.some((breadcrumb) => {
                const name = String(breadcrumb?.name || "");
                const type = String(breadcrumb?.type || "").toLowerCase();

                return type === "navigation" || name.includes("replaceState") || name.includes("pushState");
            });

            if (hasInertiaNavigation) {
                return false;
            }

            const pagePath = String(event?.request?.url || event?.context || "");
            const hasStaleCategoryRequest = breadcrumbs.some((breadcrumb) => {
                if (String(breadcrumb?.type || "").toLowerCase() !== "request") {
                    return false;
                }

                const requestUrl = String(breadcrumb?.metaData?.url || breadcrumb?.metaData?.[0]?.url || breadcrumb?.name || "");

                return requestUrl.includes("/kategoriler/") && pagePath.includes("/kategoriler/") && requestUrl !== pagePath && !pagePath.endsWith(requestUrl.replace(/^https?:\/\/[^/]+/, ""));
            });

            if (hasStaleCategoryRequest) {
                return false;
            }
        }

        return true;
    },
});
const bugsnagVue = Bugsnag.getPlugin("vue");

createInertiaApp({
    //title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob("./Pages/**/*.vue")),
    setup({ el, App, props, plugin }) {
        return createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue, Ziggy)
            .use(bugsnagVue)
            .mount(el);
    },
    progress: { color: "#70d44b", showSpinner: true },
});
